export const GET_COMPANY_TYPE_DEF = "GET_COMPANY_TYPE_DEF"
export const GET_COMPANY_TYPE_DEF_SUCCESS = "GET_COMPANY_TYPE_DEF_SUCCESS"
export const GET_DELETE_COMPANY_TYPE_DEF_FAIL = "GET_COMPANY_TYPE_DEF_FAIL"


export const ADD_COMPANY_TYPE_DEF = "ADD_COMPANY_TYPE_DEF"
export const ADD_COMPANY_TYPE_DEF_SUCCESS = "ADD_COMPANY_TYPE_DEF_SUCCESS"
export const ADD_DELETE_COMPANY_TYPE_DEF_FAIL = "ADD_COMPANY_TYPE_DEF_FAIL"

export const UPDATE_COMPANY_TYPE_DEF = "UPDATE_COMPANY_TYPE_DEF"
export const UPDATE_COMPANY_TYPE_DEF_SUCCESS = "UPDATE_COMPANY_TYPE_DEF_SUCCESS"
export const UPDATE_COMPANY_TYPE_FAIL = "UPDATE_COMPANY_TYPE_DEF_FAIL"

export const DELETE_COMPANY_TYPE_DEF = "DELETE_COMPANY_TYPE_DEF"
export const DELETE_COMPANY_TYPE_DEF_SUCCESS = "DELETE_COMPANY_TYPE_DEF_SUCCESS"
export const DELETE_COMPANY_TYPE_DEF_FAIL = "DELETE_COMPANY_TYPE_DEF_FAIL"

export const COMPANY_TYPE_DEF_API_ERROR = "API_ERROR"